require("../../libs/plugins/owl.carousel");
const { CriteoCartPage } = require("./_cartPage");
const { CriteoHomePage } = require("./_homePage");
const { CriteoProductPage } = require("./_productPage");

const criteoPLP = new CriteoProductPage();
const criteoHome = new CriteoHomePage();
const criteoBasket = new CriteoCartPage();

const initializeCriteoCarousel = async () => {
  // Check if Criteo carousel exists
  const criteoCarousel = document.getElementById("criteo-owl");
  if (!criteoCarousel) {
    console.log("[Criteo Carousel] Criteo carousel not found on this page");
    return;
  }

  // Criteo carousel doesn't require financing simulator variables
  console.log(
    "[Criteo Carousel] Found Criteo carousel, proceeding with initialization...",
  );

  let items = 6;
  let itemsAdded = 0;

  try {
    if (criteoCarousel.classList.contains("template-home")) {
      console.log("[Criteo Carousel] Loading Criteo home recommendations...");
      itemsAdded = await criteoHome.exec();
    }

    if (criteoCarousel.classList.contains("template-pdp")) {
      console.log(
        "[Criteo Carousel] Loading Criteo product recommendations...",
      );
      itemsAdded = await criteoPLP.exec();
    }

    if (criteoCarousel.classList.contains("template-basket")) {
      console.log("[Criteo Carousel] Loading Criteo cart recommendations...");
      itemsAdded = await criteoBasket.exec();
    }

    if (itemsAdded) {
      items = Math.min(itemsAdded - 1, 3);
      console.log(
        "[Criteo Carousel] Criteo loaded ${itemsAdded} items successfully",
      );
    }
  } catch (error) {
    console.log(
      "[Criteo Carousel] Criteo loading failed, using default configuration:",
      error,
    );

    // Remove criteo owl carousel from DOM if it exists
    const criteoOwlElement = document.getElementById("criteo-owl-carousel");
    if (criteoOwlElement) {
      console.log(
        "[Criteo Carousel] Removing criteo-owl-carousel from DOM due to Criteo failure",
      );
      criteoOwlElement.remove();
    }

    // Skip initialization of failed Criteo carousel
    console.log(
      "[Criteo Carousel] Skipping initialization of failed Criteo carousel",
    );
    return;
  }

  // Initialize the Criteo carousel with calculated items
  console.log(
    `[Criteo Carousel] Initializing Criteo carousel with ${items} items`,
  );

  // Check if owlCarousel is available
  if (typeof $.fn.owlCarousel === "undefined") {
    console.error("[Criteo Carousel] owlCarousel plugin not available!");
    return;
  }

  $(criteoCarousel).owlCarousel({
    stagePadding: 500,
    items: items,
    loop: false,
    navigation: true,
    addClassActive: true,
    afterInit: SetOwlCarouselFirstLast,
    afterAction: SetOwlCarouselFirstLast,
    autoPlay: 10000,
    itemsDesktop: [1199, Math.min(items, 3)],
    itemsDesktopSmall: [979, Math.min(items, 2)],
    itemsTablet: [768, Math.min(items, 2)],
    itemsTabletSmall: [480, 1],
    itemsMobile: [360, 1],
  });
};

function SetOwlCarouselFirstLast(el) {
  el.find(".owl-item").removeClass("first");
  el.find(".owl-item.active").first().addClass("first");
  el.find(".owl-item").removeClass("last");
  el.find(".owl-item.active").last().addClass("last");
}

// Initialize when DOM is ready - with a delay to ensure generic carousels are initialized first
window.addEventListener("DOMContentLoaded", () => {
  console.log(
    "[Criteo Carousel] DOM loaded, scheduling Criteo carousel initialization...",
  );
  setTimeout(initializeCriteoCarousel, 200); // Delay to ensure owl-carousel library is loaded and generic carousels are done
});

export { initializeCriteoCarousel };
